@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.pushpayload

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.dto.core.KmmLong
import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.models.pushpayload.PushDeliveryPriority
import com.narbase.letsgo.web.models.pushpayload.PushDeliveryType

object SendPushPayloadEndpoint :
    EndPoint<SendPushPayloadEndpoint.Request, SendPushPayloadEndpoint.Response>() {
    class Request(
        val passengerIds: Array<KmmLong>,
        val payloadJson: String,
        val useSandbox: Boolean,
        @Suppress("NON_EXPORTABLE_TYPE") val priority: DtoName<PushDeliveryPriority>,
        @Suppress("NON_EXPORTABLE_TYPE") val deliveryType: DtoName<PushDeliveryType>,
        val expiresInSeconds: Int?,
        val alertTitle: String?,
        val alertBody: String?,
    )

    class Response(
        val results: Array<SendResultDto>,
        val sentCount: Int,
        val failedCount: Int,
    )

    class SendResultDto(
        val passengerId: KmmLong,
        val fullName: String,
        val platform: String,
        val isSent: Boolean,
        val statusCode: Int?,
        val providerMessageId: String?,
        val errorCode: String?,
        val failureReason: String?,
        val tokenInvalidatedOn: String?,
        val sentOn: String,
    )
}
